import { useQuery } from "@tanstack/react-query";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { getTaskIdWorkflowsV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useTaskWorkflowsQuery = (id: number) => {
	return useQuery({
		queryKey: TaskKeys.workflows(id),
		queryFn: processResponse(() => getTaskIdWorkflowsV2(id)),
		enabled: id !== 0,
	});
};
